// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "4a2f4d0/js/" + chunkId + ".js";
};